import { FlexBox } from '@airship-platform/jam-web/components';
import { Box, Typography } from '@mui/material';
import SystemTypeImage from '../../../../patterns/components/SystemTypeImage';
import { InstalledEquipmentResponseExtended } from '../details-page/ExistingSystem';

const SeeDetailsExistingSystem: React.FC<{
  equipment: InstalledEquipmentResponseExtended;
}> = ({ equipment }) => {
  const data: { key: string; value: string }[] = [
    { key: 'Model number', value: equipment.model },
    { key: 'Serial number', value: equipment.serialNumber },
    { key: 'Age', value: equipment.age },
    { key: 'Output', value: equipment.capacityText },
    { key: 'Efficiency', value: equipment.efficiencyText },
    { key: 'Warranty', value: equipment.warrantyText },
  ];
  return (
    <FlexBox flexDirection="column" gap={3}>
      <Box sx={{ display: 'grid', gridTemplateColumns: `1fr 1fr` }}>
        <SystemTypeImage systemTypeId={equipment.locationEquipmentId} />
        <Typography variant="h3">{equipment.name}</Typography>
      </Box>
      <FlexBox flexDirection={'column'} gap={1}>
        {data.map((item) => (
          <Box key={item.key}>
            <Typography variant="h4">{`${item.key}: `}</Typography>
            <Typography variant="body1">{item.value}</Typography>
          </Box>
        ))}
      </FlexBox>
    </FlexBox>
  );
};

export default SeeDetailsExistingSystem;
